/**
 * Same as EmbeddedPromoTemplatePage, but requires prefetched page data rather than slug and domain.
 */
import * as React from 'react';

import EmbeddedPageContentByPageData from 'bundles/promo-template/contentful/pages/EmbeddedPageContentByPageData';
import type { PageData } from 'bundles/promo-template/queries/hooks/useEmbeddedPageContentQuery';

type Prop = {
  page?: PageData;
};

const EmbeddedPromoTemplatePageByPageData = ({ page }: Prop) => {
  if (!page) {
    return null;
  }

  return (
    <section className="rc-EmbeddedPromoTemplatePage">
      <EmbeddedPageContentByPageData page={page} />
    </section>
  );
};

export default EmbeddedPromoTemplatePageByPageData;
